function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  width: 40,
  height: 40,
  rx: 5,
  fill: "#5CDEFB"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11.1831,
  y: 17.6934,
  width: 9.17986,
  height: 3.61631,
  transform: "rotate(-45 11.1831 17.6934)",
  fill: "#44C9E7"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 29.3337,
  y: 17.6953,
  width: 9.17986,
  height: 3.61631,
  transform: "rotate(-45 29.3337 17.6953)",
  fill: "#44C9E7"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 9.17986,
  height: 3.61631,
  transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 11.1211 17.6704)",
  fill: "#32B7D5"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 9.17986,
  height: 3.61631,
  transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 29.2954 17.6704)",
  fill: "#32B7D5"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 9.17986,
  height: 3.61631,
  transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 38.3828 8.60754)",
  fill: "#32B7D5"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 29.3127,
  y: 35.754,
  width: 9.17986,
  height: 3.61631,
  transform: "rotate(-45 29.3127 35.754)",
  fill: "#44C9E7"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 11.1599,
  y: 35.754,
  width: 9.17986,
  height: 3.61631,
  transform: "rotate(-45 11.1599 35.754)",
  fill: "#44C9E7"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  width: 9.17986,
  height: 3.61631,
  transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 11.1211 35.754)",
  fill: "#32B7D5"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  width: 9.17986,
  height: 3.61631,
  transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 29.2954 35.754)",
  fill: "#32B7D5"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 17.6509,
  y: 11.167,
  width: 9.17986,
  height: 3.61631,
  transform: "rotate(-135 17.6509 11.167)",
  fill: "#32B7D5"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  width: 9.17986,
  height: 3.61631,
  transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 4.62988 11.167)",
  fill: "#44C9E7"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  width: 9.17986,
  height: 3.61631,
  transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 22.804 11.167)",
  fill: "#44C9E7"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 17.6509,
  y: 29.2468,
  width: 9.17986,
  height: 3.61631,
  transform: "rotate(-135 17.6509 29.2468)",
  fill: "#32B7D5"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 35.8247,
  y: 29.3408,
  width: 9.17986,
  height: 3.61631,
  transform: "rotate(-135 35.8247 29.3408)",
  fill: "#32B7D5"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  width: 9.17986,
  height: 3.61631,
  transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 4.62939 29.2468)",
  fill: "#44C9E7"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  width: 9.17986,
  height: 3.61631,
  transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 22.8213 29.266)",
  fill: "#44C9E7"
});

function SvgTileBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileBlue);
export default __webpack_public_path__ + "static/media/tile-blue.bcecf33f.svg";
export { ForwardRef as ReactComponent };